import React, { Fragment } from 'react'
import { useColumnSearchInvoice } from './hooks/useColumnSearchInvoice'
import Navigation from 'Components/Navigation'

// CSS
import './SearchInvoicesVadIvend.css'
import { TableSearchDocuments } from 'Components/TableSearchDocuments/TableSearchDocuments'
import { SearchDocumentsVadIvendProvider } from 'state/context/SearchDocumentsVadIvendContext'

function SearchInvoicesVadIvend() {
  const columns = useColumnSearchInvoice()

  return (
    <SearchDocumentsVadIvendProvider documentType="Invoice">
      <Fragment>
        <Navigation showChangeBranch={false} />
        <section className="common-search-content">
          <header className="common-search-header">
            <h2>Buscar Facturas</h2>
          </header>
          <TableSearchDocuments columns={columns} />
        </section>
      </Fragment>
    </SearchDocumentsVadIvendProvider>
  )
}

export default SearchInvoicesVadIvend
